// Slot API: `<LeftSide>{timeline}</LeftSide>` — the children slot is the
// timeline (PR 2.2). ChatHeader and Composer are mounted internally.
import { ReactNode } from 'react';

import { ChatHeader } from './ChatHeader/ChatHeader';
import { Composer } from './Composer/Composer';

type Props = { children?: ReactNode; collectionLanguage?: string; onClose?: () => void };

export const LeftSide = ({ children, collectionLanguage, onClose }: Props) => {
  return (
    <section className="flex h-full min-w-0 flex-1 basis-0 flex-col overflow-hidden rounded-lg border border-stroke bg-background">
      <ChatHeader collectionLanguage={collectionLanguage} onClose={onClose} />
      <div className="min-h-0 flex-1 overflow-hidden">{children}</div>
      <Composer />
    </section>
  );
};
